import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dimmer,
  Dropdown,
  Grid,
  Header,
  Icon,
  Label,
  Loader,
  Menu,
  Modal,
  Table,
} from 'semantic-ui-react';

import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import config from '../../../../../config';
import { fetchM } from '../../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../../actions/flash';
import { decodeSearch, encodeSearch } from '../../../../utils/url';
import isNumber from '../../../../utils/numbers/isNumber';
import fileSize from '../../../../utils/fileSize';
import PageNav from '../../../../components/PageNav';
import NavBar from '../../../../components/NavBar';
import AddDocument from '../../../modals/AddDocument';
import LayoutTitle from '../LayoutTitle';
import { routes } from '../navigations';
import { namespaces, TRANSLATION_FILES } from '../../../../constants/translation';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    documentToken: PropTypes.string,
    id: PropTypes.string,
    unitLayoutID: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    const count = props.count;
    const limit = props.limit;
    const offset = props.offset;
    const documents = props.documents || [];
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const menuIsTab = window.innerWidth <= 590;
    return {
      documents,
      loading,
      count,
      limit,
      offset,
      currentPage,
      menuIsTab,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState(props);
    this.state = {
      ...state,
      options: [],
      selectedFile: null,
      showRemove: false,
      showAddDocument: false,
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  replaceQuery(query) {
    const { store } = this.context;
    store.dispatch(replace(`/projects/${this.props.id}/layouts/${this.props.unitLayoutID}/documents/?${encodeSearch(query)}`));
  }
  handleChangePage = (page) => {
    const query = decodeSearch(this.props.location.search);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    const currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    this.setState({ currentPage });
    this.replaceQuery(query);
  }
  handleCancelRemove = (e) => {
    e.preventDefault();
    this.setState({
      showRemove: false,
      selectedFile: null,
    });
  }
  handleRemove = (e, selectedFile) => {
    e.preventDefault();
    this.setState({
      selectedFile,
    }, () => {
      this.setState({
        showRemove: true,
      });
    });
  }
  handleConfirmRemove = (e) => {
    e.preventDefault();
    this.setState({
      showRemove: false,
    }, () => {
      this.removeDocument();
    });
  }
  addDocument() {
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/documents/${this.state.selectedFile.id}/`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.documentToken,
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then(() => {
        this.handleChangePage();
        store.dispatch(flashSuccessMessage({ header: 'Add Success', message: 'Document successfully added to unit layout' }));
      });
  }
  removeDocument() {
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/documents/${this.state.selectedFile.id}/`, {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.documentToken,
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then(() => {
        this.setState({
          selectedFile: null,
          loading: false,
        });
        this.handleChangePage();
        store.dispatch(flashSuccessMessage({ header: 'Remove Success', message: 'Document successfully deleted' }));
      });
  }
  handleUpload = body => ({
    url: `/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/documents/`,
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        // Let browser decide Content-Type
        'X-Csrf-Token': this.props.documentToken,
      },
      body,
    },
  })
  handleShowAddDocument = (e) => {
    e.preventDefault();
    this.setState({
      showAddDocument: true,
    });
  }
  handleCloseAddDocument = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleChangePage();
    this.setState({
      showAddDocument: false,
    });
  }
  handleAddDocument = (e, selectedFile) => {
    e.preventDefault();
    this.setState({
      showAddDocument: false,
      selectedFile,
    }, () => {
      this.addDocument();
    });
  }
  handleCheck = (data) => {
    if (data.unitLayouts && data.unitLayouts.length > 0) {
      return data.unitLayouts.some(p => p.id === this.props.unitLayoutID);
    }
    return false;
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    store.dispatch(replace(value));
  }
  render() {
    const { t } = this.props;
    const { pathname } = this.props.location;
    const { store } = this.context;
    const links = routes(this.props.id, this.props.unitLayoutID, true);
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={t(link.text)}
                active={pathname === link.value}
                onClick={() => store.dispatch(replace(link.value))}
              />
            ))
          }
          rightNav={
            <Menu.Item fitted>
              <Button
                onClick={this.handleShowAddDocument}
                disabled={this.state.loading}
                primary
                icon="add"
                content={t('Add', { ns: TRANSLATION_FILES.translation })}
              />
            </Menu.Item>
          }
        />
        <LayoutTitle data={this.props.data} />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <AddDocument
                open={this.state.showAddDocument}
                onClose={this.handleCloseAddDocument}
                onConfirm={this.handleAddDocument}
                onUpload={this.handleUpload}
                onCheck={this.handleCheck}
              />
              <Modal
                open={this.state.showRemove}
                onClose={this.handleCancelRemove}
              >
                <Header icon="warning sign" content="Confirm remove?" />
                <Modal.Content>
                  <Modal.Description>
                    <Header
                      as="h3"
                      content="Are you sure to remove this file?"
                      subheader={this.state.selectedFile ? this.state.selectedFile.name : ''}
                    />
                  </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                  <Button basic negative onClick={this.handleCancelRemove} icon="cancel" content="No" inverted />
                  <Button basic positive onClick={this.handleConfirmRemove} icon="remove" content="Yes" inverted />
                </Modal.Actions>
              </Modal>
              <Dimmer
                inverted style={{ zIndex: 20 }}
                active={this.state.loading && this.state.documents.length > 0}
              >
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <Table
                striped unstackable
                selectable
              >
                <Table.Header fullWidth>
                  <Table.Row>
                    <Table.HeaderCell colSpan={4} textAlign="right">
                      <PageNav
                        currentPage={this.state.currentPage}
                        count={this.state.count}
                        limit={this.state.limit}
                        offset={this.state.offset}
                        dataSize={this.state.documents.length}
                        loading={this.state.loading}
                        onChange={this.handleChangePage}
                      />
                    </Table.HeaderCell>
                  </Table.Row>
                  <Table.Row>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Size</Table.HeaderCell>
                    <Table.HeaderCell>Tags</Table.HeaderCell>
                    <Table.HeaderCell />
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    this.state.documents.length > 0 ?
                      this.state.documents.map((file, key) => (
                        <Table.Row key={key}>
                          <Table.Cell width={6}>
                            <a
                              href={`${config.get('bookApiURL')}/documents/${file.id}/view/${encodeURIComponent(file.name)}.pdf`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Icon name="file pdf outline" />
                              {file.name}
                            </a>
                          </Table.Cell>
                          <Table.Cell collapsing>
                            {fileSize(file.size)}
                          </Table.Cell>
                          <Table.Cell>
                            <Label.Group size="tiny">
                              {
                                file.tags && file.tags.length > 0 ?
                                file.tags.map((tag, idx) => (
                                  <Label key={idx} as="a">{tag}</Label>
                                ))
                                : <p>{t('No tags set', { ns: TRANSLATION_FILES.translation })}</p>
                              }
                            </Label.Group>
                          </Table.Cell>
                          <Table.Cell collapsing textAlign="right">
                            <Button
                              size="tiny"
                              compact
                              negative
                              icon="remove"
                              disabled={this.state.loading}
                              onClick={e => this.handleRemove(e, file)}
                            />
                          </Table.Cell>
                        </Table.Row>
                      ))
                    :
                      <Table.Row>
                        <Table.Cell colSpan={4} textAlign="center">
                          {
                            this.state.loading ?
                              <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                            : t('No documents found.', { ns: TRANSLATION_FILES.translation })
                          }
                        </Table.Cell>
                      </Table.Row>
                  }
                </Table.Body>
                <Table.Footer fullWidth>
                  <Table.Row>
                    <Table.HeaderCell colSpan={4} textAlign="right">
                      <PageNav
                        currentPage={this.state.currentPage}
                        count={this.state.count}
                        limit={this.state.limit}
                        offset={this.state.offset}
                        dataSize={this.state.documents.length}
                        loading={this.state.loading}
                        onChange={this.handleChangePage}
                      />
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(...namespaces)(List);



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayout/Documents/List.jsx